/**
 * Números e endereços fixos dos plugins web (docs/spec/web-plugins.md, "Pacote").
 */

/** Versão do formato do manifesto (`"rpgdesk": 1`). */
export const MANIFEST_VERSION = 1;
/** Versão maior do SDK que este RPG Desk entende (`"sdk": 1`). */
export const SDK_MAJOR = 1;

/**
 * Endereço público do SDK. Funciona fora do RPG Desk (arquivo aberto no computador, prévia de uma
 * IA); dentro dele, o servidor troca pela cópia dele (`/_sdk/1/`), para a versão bater.
 */
export const SDK_CDN_BASE = 'https://cdn.jsdelivr.net/npm/@rpgdesk/sdk@1/';

export const PACKAGE_LIMITS = {
  /** o pacote (.zip, ou o .html) */
  maxBytes: 10 * 1024 * 1024,
  maxFiles: 500,
  /** o `example` de cada webhook no manifesto, em JSON */
  maxExampleBytes: 4096,
  maxWebhooks: 20,
  maxTypes: 20,
} as const;

/** Tipo de cada extensão aceita no pacote; o que não está aqui não entra. */
export const MIME_TYPES: Readonly<Record<string, string>> = {
  html: 'text/html; charset=utf-8',
  htm: 'text/html; charset=utf-8',
  css: 'text/css; charset=utf-8',
  js: 'text/javascript; charset=utf-8',
  mjs: 'text/javascript; charset=utf-8',
  json: 'application/json; charset=utf-8',
  txt: 'text/plain; charset=utf-8',
  md: 'text/markdown; charset=utf-8',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  woff2: 'font/woff2',
  woff: 'font/woff',
  ttf: 'font/ttf',
  otf: 'font/otf',
  mp3: 'audio/mpeg',
  ogg: 'audio/ogg',
  wav: 'audio/wav',
};

export function extensionOf(path: string): string {
  const name = path.slice(path.lastIndexOf('/') + 1);
  const dot = name.lastIndexOf('.');
  return dot > 0 ? name.slice(dot + 1).toLowerCase() : '';
}

/** Tipo (Content-Type) de um arquivo do pacote, ou null se a extensão não é aceita. */
export function mimeOf(path: string): string | null {
  return MIME_TYPES[extensionOf(path)] ?? null;
}

export const isHtmlPath = (path: string): boolean => ['html', 'htm'].includes(extensionOf(path));
const TEXT_EXTENSIONS = new Set(['html', 'htm', 'css', 'js', 'mjs', 'json', 'txt', 'md', 'svg']);
export const isTextPath = (path: string): boolean => TEXT_EXTENSIONS.has(extensionOf(path));
